var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-68",
    d: "M91.46,439c88.76,45.38,232.66,45.39,321.42,0s88.76-119,0-164.34-232.66-45.38-321.42,0S2.7,393.65,91.46,439Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-68"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "freepik--Shadow--inject-68",
    points: "148.53 388.87 100.61 361.39 163.75 325.88 148.82 389.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-68",
    cx: 414.65,
    cy: 346.24,
    rx: 47.48,
    ry: 25.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-68",
    d: "M237.62,364.25l42.67,24.64a11.37,11.37,0,0,0,10.26,0l86-49.64c2.83-1.64,2.83-4.29,0-5.92l-42.67-24.64a11.37,11.37,0,0,0-10.26,0l-86,49.64C234.78,360,234.78,362.62,237.62,364.25Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.52,345.41c-.63-7.77-4.19-20.54-13.23-32.7-9.67-13-21.47-21.14-30.23-17.34-8.16,3.55-5.07,14.81,9,25.93,9.85,7.79,20.07,17.94,25.57,30.19l8.91,15.59Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.52,345.41c-.63-7.77-4.19-20.54-13.23-32.7-9.67-13-21.47-21.14-30.23-17.34-8.16,3.55-5.07,14.81,9,25.93,9.85,7.79,20.07,17.94,25.57,30.19l8.91,15.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M77.73,351.34a.55.55,0,0,1-.52-.37c-7.83-21.55-24.13-43.36-37.92-50.73a.55.55,0,1,1,.52-1c14,7.49,30.53,29.55,38.44,51.34a.55.55,0,0,1-.33.7A.46.46,0,0,1,77.73,351.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.73,372a32.79,32.79,0,0,1-15.6,6.68C52.3,380.22,48,375.52,48,375.52s3.87-9.22,9.46-11.81a54.79,54.79,0,0,0-17.06,7s-6,.09-8.39-9.07c0,0,3.55-5.51,15.48-8.49,0,0-7.25-1.83-17.71.84-.79.31-4.13-11.53-5.14-17s1.18-5.41,5.44-6.55,18.76-1.85,21.43.5,4,10.35,4,10.35,2.55-4.53,1.94-8.58a15.22,15.22,0,0,1,9.06.22c4.79,1.66,4.48,4,4.48,7.48a36.75,36.75,0,0,1-1.43,10.37s3.31-2.86,3.42-13.4c0,0,6.47,5.53,9.07,10.29S84,364.88,77.73,372Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.73,372.53a.55.55,0,0,1-.5-.31c-7.93-16.48-37.42-35.62-48-37.68a.56.56,0,0,1-.44-.65.55.55,0,0,1,.65-.43C40.2,335.55,70.17,355,78.23,371.74a.56.56,0,0,1-.26.74A.52.52,0,0,1,77.73,372.53Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Documents--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.69 197.2 75.69 376.72 243.22 279.99 243.22 117.97 128.78 183.99 124.48 168.97 75.69 197.2",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.69 376.72 84.28 219.08 251.81 122.36 243.22 279.99 75.69 376.72",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.69 376.72 90.86 223.47 258.39 126.75 243.22 279.99 75.69 376.72",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,389.57c-.47,0-.54-.54-.54-.86V158.07a3.87,3.87,0,0,1,1.73-3L311.26,61.69a1.25,1.25,0,0,1,.61-.2c.46,0,.53.54.53.86V293a3.87,3.87,0,0,1-1.73,3L148.82,389.37A1.31,1.31,0,0,1,148.21,389.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.79,62.09a.79.79,0,0,1,0,.26V293a3.37,3.37,0,0,1-1.44,2.49L148.53,388.87a.84.84,0,0,1-.25.1,1.42,1.42,0,0,1,0-.26V158.07a3.34,3.34,0,0,1,1.43-2.49L311.55,62.19a.94.94,0,0,1,.24-.1m.08-1.18a1.78,1.78,0,0,0-.9.27L149.11,154.57a4.46,4.46,0,0,0-2,3.5V388.71c0,.91.45,1.44,1.12,1.44a1.88,1.88,0,0,0,.9-.27L311,296.49a4.5,4.5,0,0,0,2-3.5V62.35c0-.92-.46-1.44-1.12-1.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.31 163.95 208.71 136.58 208.71 191.31 161.31 218.68 161.31 163.95",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.6,150.26v16.42l-1.49.83v-5c0-2.78-2.26-3.72-5.05-2.11L175,172c-2.79,1.61-5.06,5.17-5.06,7.94v5l-1.48.89V169.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.46,192.11c-2.44,1.41-4.41-.07-4.41-3.29V162.48L182,165.8v26.54c0,3.22-2,7-4.41,8.37l-4.4,2.54V205l23.7-13.69v-1.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,133.85c0,1.51,1.36,2,3,1l74.52-43a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-1.95-3-1l-74.52,43A6.06,6.06,0,0,0,218.19,133.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,150.26c0,1.52,1.36,2,3,1l74.52-43a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-2-3-1l-74.52,43A6.06,6.06,0,0,0,218.19,150.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,166.68c0,1.52,1.36,2,3,1l74.52-43a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-2-3-1l-74.52,43A6.06,6.06,0,0,0,218.19,166.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,183.1c0,1.51,1.36,2,3,1l74.52-43a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-1.95-3-1l-74.52,43A6.06,6.06,0,0,0,218.19,183.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,232.37c0,1.51,1.36,1.95,3,1l131.4-75.8a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-1.95-3-1l-131.4,75.81A6.09,6.09,0,0,0,161.31,232.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,248.79c0,1.51,1.36,2,3,1L295.74,174a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-1.95-3-1L164.34,244.3A6.09,6.09,0,0,0,161.31,248.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,265.21c0,1.51,1.36,2,3,1l131.4-75.8a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-2-3-1l-131.4,75.81A6.09,6.09,0,0,0,161.31,265.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,281.62c0,1.51,1.36,2,3,1l131.4-75.81a6.06,6.06,0,0,0,3-4.48c0-1.52-1.36-2-3-1l-131.4,75.81A6.06,6.06,0,0,0,161.31,281.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,298c0,1.51,1.36,1.95,3,1l131.4-75.81a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-1.95-3-1l-131.4,75.8A6.09,6.09,0,0,0,161.31,298Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,314.46c0,1.51,1.36,2,3,1l131.4-75.8a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-2-3-1L164.34,310A6.09,6.09,0,0,0,161.31,314.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,330.87c0,1.51,1.36,2,3,1l131.4-75.81a6.06,6.06,0,0,0,3-4.48c0-1.52-1.36-2-3-1l-131.4,75.81A6.06,6.06,0,0,0,161.31,330.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,347.29c0,1.51,1.36,1.95,3,1l131.4-75.81a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-2-3-1l-131.4,75.8A6.09,6.09,0,0,0,161.31,347.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,363.71c0,1.51,1.36,2,3,1l131.4-75.8a6.09,6.09,0,0,0,3-4.49c0-1.51-1.36-1.95-3-1l-131.4,75.81A6.09,6.09,0,0,0,161.31,363.71Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.67,245.46a31.32,31.32,0,0,1,4.8-16.46v-9.29a2.94,2.94,0,0,0-1.05-2.52h0a1.64,1.64,0,0,0-.29-.16L337,199.6l0,0,0,0h0a2.87,2.87,0,0,0-2.82.3l-23.75,13.71a9.13,9.13,0,0,0-3.93,7c-.27,6.8-2.49,19.39-14.5,26.32s-14.26-3.22-14.51-9.7c-.1-2.58-1.69-3.62-3.92-2.33l-23.76,13.71a8.93,8.93,0,0,0-4,7v9.29s4.8,1.34,4.8,10.92-7.42,26.95-7.42,51.06c0,12.07,3.83,22.15,11.87,26.78h0l30.19,17.42h0c8,4.72,20.26,4,37.13-5.78,33.58-19.39,48.84-53.21,48.84-77.31S363.67,255,363.67,245.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.08,199.87l-23.75,13.71a9.11,9.11,0,0,0-3.93,7c-.25,6.27-2.15,17.45-11.85,24.58l-18.27-10.55-.1-.05a2.68,2.68,0,0,0-2.71.31l-23.76,13.71a5.9,5.9,0,0,0-.93.67,8.85,8.85,0,0,0-1.93,2.34,8.41,8.41,0,0,0-1.18,4v9.29l1.31.76c1.44,1.16,3.49,3.9,3.49,10.15,0,9.58-7.42,27-7.42,51.06,0,12.07,3.83,22.17,11.87,26.8L285,371c-7.89-4.69-11.64-14.69-11.64-26.65,0-24.11,7.41-41.49,7.41-51.07s-4.8-10.91-4.8-10.91v-9.29a9,9,0,0,1,4-7l23.76-13.71a2.74,2.74,0,0,1,2.62-.36l.1,0a3,3,0,0,1,1.2,2.63c.24,6.49,2.42,16.69,14.51,9.71s14.23-19.52,14.51-26.32a9.09,9.09,0,0,1,3.92-7l23.75-13.71a2.9,2.9,0,0,1,2.71-.35L337,199.6A2.88,2.88,0,0,0,334.08,199.87Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,265.63h0l0,0,29,16.73v-9.29a8.2,8.2,0,0,1,1.19-4h0L246.85,251.6a8.37,8.37,0,0,0-1.18,4v9.29h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.55,245.16l-18.27-10.55-.1-.05a2.68,2.68,0,0,0-2.71.31l-23.76,13.71a5.9,5.9,0,0,0-.93.67,8.85,8.85,0,0,0-1.93,2.34l30.35,17.52a8.23,8.23,0,0,1,2.85-3l23.76-13.71a2.74,2.74,0,0,1,2.62-.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,217,337,199.6a2.88,2.88,0,0,0-2.88.27l-23.75,13.71a7.79,7.79,0,0,0-2.76,3l30.34,17.51a7.79,7.79,0,0,1,2.76-3l23.75-13.71A2.9,2.9,0,0,1,367.13,217Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,234.1a9.51,9.51,0,0,0-1.17,4c-.27,6.8-2.5,19.39-14.5,26.32s-14.27-3.22-14.51-9.71a3,3,0,0,0-1.2-2.63l-.1,0-11.88-6.86c9.7-7.13,11.6-18.31,11.85-24.58a9.41,9.41,0,0,1,1.17-4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,371l-30.12-17.37c-8-4.63-11.87-14.73-11.87-26.8,0-24.1,7.42-41.48,7.42-51.06,0-6.2-2-8.94-3.45-10.13l29,16.73s4.8,1.34,4.8,10.91-7.41,27-7.41,51.07C273.4,356.32,277.15,366.32,285,371Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,329.74l-13,7.5,2-23.51c-1.56-.82-2.55-2.84-2.55-5.74,0-5.18,3.15-11.19,7-13.44s7,.14,7,5.32a17.73,17.73,0,0,1-2.54,8.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.13 329.74 317.36 322.94 316.13 337.24 329.13 329.74",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.63,294.55c-2.54,1.47-4.76,4.55-6,8l10.48,6.05h0a17.73,17.73,0,0,0,2.54-8.69C329.66,294.69,326.51,292.31,322.63,294.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.32,157.87c-6.43-3.71-14.5-3.29-22.17,1.13l-28.33,16.36c-12.28,7.09-21.54,23.13-21.54,37.3v38.25h0c0,1.58,1.06,3.17,3.15,4.38a16.76,16.76,0,0,0,15.17,0c2.09-1.21,3.15-2.8,3.15-4.38h0V212.66c0-6.52,5.15-15.44,10.8-18.7l28.33-16.36.07,0v38.32h0c0,1.59,1.06,3.17,3.15,4.38a16.76,16.76,0,0,0,15.17,0c2.09-1.21,3.15-2.79,3.15-4.38h0V177.64C347.42,168.78,343.74,161.58,337.32,157.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,177.64v38.24c0,1.59,1.06,3.17,3.15,4.38a13,13,0,0,0,3.16,1.26v-47.6L326,177.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.22,217.73c-1.66-.48-3-1.42-5.39-1.9a10.36,10.36,0,0,1-4.63-1.77c-1.8-1.21-5.33-6.41-8.12-11.59a57.92,57.92,0,0,1-5.6-18.76c-.65-7.87-2.47-18.4-2.94-23-.76-7.26-2.92-11-11.31-10.49,0,0,2.25,2.56,1.6,9.12s1.24,18,2.66,26.88c.69,4.3,2.94,10.2,7.15,18.08,2.93,5.5,5.59,10.14,9.68,14.84,1.11,1.28,1.62,2.51,3.46,5.21a13.28,13.28,0,0,0,2.56,3.11,17.26,17.26,0,0,0,4.29,2.55,11.74,11.74,0,0,0,6.19.79A7.4,7.4,0,0,0,457,229.6a4.9,4.9,0,0,0,1.94-2.8,1.35,1.35,0,0,0,0-.69c-.12-.41-.53-.65-.9-.86a70.47,70.47,0,0,1-6.45-3.38c-1.64-1.13-2.64-2.15-2.26-2.25s1.31.63,3,.85,3.39-.57,3.43-1.5S455.88,218.21,454.22,217.73Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,149.77c3-.2,9.46-1,11.4,5.09s4.18,28.85,4.78,31.74a85.2,85.2,0,0,0,4,12.84c1.76,4.32,6.87,13.13,6.87,13.13L436.34,218s-8.92-10.35-13.5-21.34-6-25.18-6.23-33.63A116.38,116.38,0,0,0,415.66,149.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,149.77c3-.2,9.46-1,11.4,5.09s4.18,28.85,4.78,31.74a85.2,85.2,0,0,0,4,12.84c1.76,4.32,6.87,13.13,6.87,13.13L436.34,218s-8.92-10.35-13.5-21.34-6-25.18-6.23-33.63A116.38,116.38,0,0,0,415.66,149.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.35 335.15 430.25 335.46 430.7 319.31 421.79 319 421.35 335.15",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.01,
    y: 330.98,
    width: 8.91,
    height: 15.26,
    transform: "translate(784.94 677.21) rotate(180)",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.93,341.84v-1.28c.85.37,2.83,7.93,6.37,11.16,2.81,2.56,6.64,5.52,7.62,8.38s-5.34,4.62-8,4.15c-3.05-.54-8.34-2.69-9.67-4.68s-1.95-4.93-3-6.39-3.56-3.09-4.15-4.78c-.32-.93.06-3,.51-4.68s.87-3.31,1.4-3.16v1a7.06,7.06,0,0,0,4.46,1.51C393.77,343.09,396.94,342.83,396.93,341.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.35,332.71c.46,0,.84.67,1.86,1.77a19.17,19.17,0,0,0,5.24,3.77c3.34,1.68,9.83,4.25,12.76,5.57,1.84.82,1.75,3-.14,4.3s-6.48,2.17-12,.94c-3-.67-6.89-3.43-9.36-3.28s-7.08.11-8.9-1.15-1.1-3.93-.58-6.24c.56-2.51,1.36-6.36,2.2-6.19l0,.79c1.07,1.63,6.53,2.29,8.88,1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.82,204.57c-7,14.34-.09,68.42-.09,68.42-.25,2.34-3.05,6.91-4.29,17.24-1.46,12.2-.2,43.56-.2,43.56s5.82,2.58,10.56.44c0,0,8.37-46.54,10.19-58.66,1.58-10.58,4.69-33.86,4.69-33.86l6.52,34.06a62.49,62.49,0,0,0-2.56,10.42c-.86,7.13,4.26,40.41,4.26,40.41a15.45,15.45,0,0,0,10,.67s3-44.17,3.88-52.77c1.42-14.44-2.77-59.61-4.25-69.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.14,150.09h0c-2.25.26-7.45,1.17-7.45,1.17-3.45,1.26-3.08,3.38-4,6.69-1.18,4.1-.41,11.42,1,15.45l6.68,19.31c-2.5,6-4.9,7.78-6.1,12.37,10.91,8.09,34.36,7.61,39.4.79.21-1.45-1.71-18.06-2.51-25.45,3.4-6.17,4.7-10.59,2.92-15.32-3.05-8.09-11.41-15.65-15.38-15.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92,143.14h-3.29a17.35,17.35,0,0,1-17.35-17.35h0a17.44,17.44,0,0,1,17.44-17.44h3.11a17.44,17.44,0,0,1,17.44,17.44h0A17.35,17.35,0,0,1,407.92,143.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39,151.12h0a10.69,10.69,0,0,0,10.7-10.69V117.52h0a10.7,10.7,0,0,0-10.7,10.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.59,114.68c2.09,1.24,4.68,6.51,4.42,17.55-.21,9.35-3.25,11.66-4.77,12.33s-4.46.26-7.32-.22V150l-.57,6.59-11.18-5.11V137.87s-1.93,2.57-5.08.48-3.27-7.28-1.44-9.14,5.79-1.27,6.52,1.3c0,0,1.28-2.69,7.82-4.93C414.88,123.22,417.17,119.08,419.59,114.68Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.52,129.88a1.18,1.18,0,1,1-1.24-1.17A1.21,1.21,0,0,1,412.52,129.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.88,137.81l2.73.87a1.4,1.4,0,0,1-1.77,1A1.5,1.5,0,0,1,413.88,137.81Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.16,126.26l-2.38-1.65a1.39,1.39,0,0,1,2-.4A1.5,1.5,0,0,1,422.16,126.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.62,129a1.18,1.18,0,1,1-2.35.12,1.19,1.19,0,0,1,1.11-1.28A1.21,1.21,0,0,1,421.62,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.87 128.35 416.06 135.43 419.78 134.28 415.87 128.35",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92,144.34c-3-.39-9.19-2.17-10.16-4.62a6.35,6.35,0,0,0,2.17,3.13c1.85,1.58,8,3.37,8,3.37Z",
    style: {
      fill: "#9a4a4d"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.68,241.71l3.4-16.51s7.1-1.19,10.87-3.88a19.63,19.63,0,0,1-8.05,5.81L415,242.71l1,16.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.94,119.72s13.44,9.15,22.78,4.58-2.76-11-2.76-11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,100.54c-8-2.24-16.67-3.68-26.75,0s-12.28,9.9-12.28,9.9,10.26,4.06,18.61,2.69S419.86,100.54,419.86,100.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,100.54c-8-2.24-16.67-3.68-26.75,0s-12.28,9.9-12.28,9.9,10.26,4.06,18.61,2.69S419.86,100.54,419.86,100.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,114.21s-5.13-2.44-5.61-3.79a33.79,33.79,0,0,0,11.93-.77c6.67-1.61,13.61-8.09,21.12-9.23s10.71,2.69,10.71,2.69-1.66,5.34-4.26,8.58c0,0-2.32,5.07-11.16,6.24S386.44,114.21,386.44,114.21Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,114.21l.42,1.46a3.77,3.77,0,0,0,2,2.26,37.11,37.11,0,0,0,20.55,2c6.21-1.15,9-2.74,10.13-3.94a3.1,3.1,0,0,0,1-2.9l-.21-1.42s-1.92,2.68-12.07,4.67S386.44,114.21,386.44,114.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.66,103.41c-.08,1.57-1.73,4.45-3.92,3.09v4c0,2.45,1.44,3.3,3.77,2.81a5,5,0,0,0,4.07-5c0-.75,0-3.4,0-3.4C416.86,107.23,414.63,104,414.66,103.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.17,132.93h0v-5.31h2.07v3.24A2.07,2.07,0,0,1,400.17,132.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.35,156.55l-11.18-8.15v-2s-2.35.4-2.92,4.88a19,19,0,0,0,8.5,9l2.31-4.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.35,156.55l-11.18-8.15v-2s-2.35.4-2.92,4.88a19,19,0,0,0,8.5,9l2.31-4.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92,146.86a5.73,5.73,0,0,1,3.65,2.19c1.1,1.81.85,8.71.85,8.71l-2.93-3.34-2.14,2.13c.24-2.3.57-6.59.57-6.59Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92,146.86a5.73,5.73,0,0,1,3.65,2.19c1.1,1.81.85,8.71.85,8.71l-2.93-3.34-2.14,2.13c.24-2.3.57-6.59.57-6.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.72,228.8c-1.39-1-2.3-2.38-4.38-3.67a10.25,10.25,0,0,1-3.72-3.28c-1.26-1.77-2.75-7.87-3.55-13.7-.95-6.88.1-16.22.59-20.08a198.5,198.5,0,0,1,4.5-22c.08-.33-1.72-10.39-3.7-12,0,0-2.27-.32-5.18,5.6s-4.34,19-5.14,27.79A81.94,81.94,0,0,0,382.5,207c.82,6.18,1.69,11.45,3.88,17.29.59,1.59.64,2.92,1.42,6.09a13.84,13.84,0,0,0,1.3,3.81,17.59,17.59,0,0,0,3.13,3.89,11.81,11.81,0,0,0,5.53,2.91,7.41,7.41,0,0,0,3.44,0A5,5,0,0,0,404,239a1.32,1.32,0,0,0,.26-.65,1.63,1.63,0,0,0-.54-1.11,70.62,70.62,0,0,1-4.85-5.42c-1.15-1.64-1.73-2.95-1.33-2.9s1,1.05,2.54,1.86,3.38.65,3.75-.21S404.11,229.82,402.72,228.8Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,151.28s5,10.09,2.77,19c-2.05,8.14-3.21,18.56-3.65,21.48a86.26,86.26,0,0,0-.8,13.42c.14,4.66,1.85,14.7,1.85,14.7l-7.83,2.9s-4.74-12.82-5.19-24.72.7-26,2.63-34.26C384.16,160.24,385.16,152.71,393.53,151.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,151.28s5,10.09,2.77,19c-2.05,8.14-3.21,18.56-3.65,21.48a86.26,86.26,0,0,0-.8,13.42c.14,4.66,1.85,14.7,1.85,14.7l-7.83,2.9s-4.74-12.82-5.19-24.72.7-26,2.63-34.26C384.16,160.24,385.16,152.71,393.53,151.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.58,168.45s7.46-.31,10.53-1.5v-1.49C409,166.65,401.58,167,401.58,167Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.28,163s2.35-.82,5.59,1l.08-.33a.79.79,0,0,0-.42-.87,7.73,7.73,0,0,0-4.54-.83.76.76,0,0,0-.61.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.07,
    cy: 167.04,
    rx: 3.24,
    ry: 2.43,
    transform: "translate(139.84 508.52) rotate(-77.44)",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.3322b0e43706c729b03060ea60597f7d.svg";
export { ForwardRef as ReactComponent };